import classNames from "classnames/dedupe";
import React, { FC } from "react";

import { TThemeVariant, useTheme } from "../../Utility/ThemeProvider";

export type IInput = JSX.IntrinsicElements["input"];

export interface IInputProps extends IInput {
  /**
   * Visual representation of component
   *
   */
  variant?: TThemeVariant;
  /**
   * Optional default value for uncontrolled input
   */
  defaultValue?: any;
}

const Input: FC<IInputProps> = ({ variant, className, ...inputProps }) => {
  const theme: TThemeVariant = useTheme(variant);

  const inputClasses = classNames("form-check-input", {
    "form-check-input--light": theme === "light",
  });

  return <input {...inputProps} className={className || inputClasses} />;
};

export default Input;
